<template>
  <div class="image-browser">
    <el-image
      :src="thumbnailSrc"
      :preview-src-list="value ? [src] : []"
      style=""
    >
      <div slot="placeholder" class="image-slot">
        加载中<span class="dot">...</span>
      </div>
    </el-image>
    <p>{{label}}</p>
  </div>
</template>

<script>
  import VueLoadImage from 'vue-load-image'
  import {getFileUrl, getImageUrl} from "../filters/CommonActions";

  export default {
    name: "PhotoBrowser",
    data() {
      return {
        dialogVisible: false,
      }
    },
    components: {
      'vue-load-image': VueLoadImage
    },
    props: {
      value: {
        type: String
      },
      label: {
        type: String,
      },
      type: {
        type: String,
        default: ''
      }
    },
    computed: {
      thumbnailSrc: function () {
        return this.getPhotoSrc(this.value, '200x240')
      },
      src: function () {
        return this.getPhotoSrc(this.value)
      }
    },
    methods: {
      browser: function () {

      },
      getPhotoSrc: function (path=null, size=null) {
        return path && (path.indexOf('images/') !== -1 || this.type=='img') ? getImageUrl(path, size) : getFileUrl(path, size)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PhotoBrowserMobile.vue